var map = {
	"./": 31504,
	"./development": 43061,
	"./development.tsx": 43061,
	"./index": 31504,
	"./index.tsx": 31504,
	"./local": 6961,
	"./local.tsx": 6961,
	"./production": 85072,
	"./production.tsx": 85072
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37055;